import { Testimonial } from '@rumblefish/ui/src/components/Rumblefish23Theme';

import mitchellMaddoxAvatar from '../../../public/webp/fromPNG/AlgeaTheme/mitchel-2.webp';
import { StyledSection } from './styles';

export const TestimonialSection = () => {
  return (
    <StyledSection width="small">
      <Testimonial
        name="Mitchell Maddox"
        positionInCompany="CEO of Woodland Russel"
        text={`
          The Rumble Fish development team is outstanding, some of
          the best engineers we’ve worked with. Highly recommended.
        `}
        avatarSrc={mitchellMaddoxAvatar}
        customStyles={{
          height: '250px',
          display: 'flex',
          justifyContent: 'center',
        }}
      />
    </StyledSection>
  );
};
